import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GenerateCanvasComponent } from './generate-canvas/generate-canvas.component';
import { CreateMapComponent } from './create-map/create-map.component';
import { MaterialModule } from 'src/app/material/material.module';
import { SelectTypeComponent } from './select-type/select-type.component';
import { NameMapComponent } from './name-map/name-map.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HiddenSeatsComponent } from './hidden-seats/hidden-seats.component';
import { EditSectionComponent } from './edit-section/edit-section.component';
import { EditSeatsComponent } from './edit-seats/edit-seats.component';
import { EditInfoSectionComponent } from './edit-info-section/edit-info-section.component';
import { CreateLevelsComponent } from './create-levels/create-levels.component';
import { CreateSeatsComponent } from './create-seats/create-seats.component';
import { LegendConfigComponent } from './legend-config/legend-config.component';
import { CurveSelectionPanelComponent } from './curve-selection-panel/curve-selection-panel.component';



@NgModule({
  declarations: [
    GenerateCanvasComponent,
    CreateMapComponent,
    SelectTypeComponent,
    NameMapComponent,
    HiddenSeatsComponent,
    EditSectionComponent,
    EditSeatsComponent,
    EditInfoSectionComponent,
    CreateLevelsComponent,
    CreateSeatsComponent,
    LegendConfigComponent,
    CurveSelectionPanelComponent,
  ],
  imports: [
    CommonModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule
  ],
  exports: [
    CreateMapComponent
  ]
})
export class SeatMapModule { }
